<!--
  Authors : initappz (Rahul Jograna)
  Website : https://initappz.com/
  App Name : Grocery Delivery App Source code is licensed as per the
  terms found in the Website https://initappz.com/license
  Copyright and Good Faith Purchasers © 2024-present initappz.
-->
<div class="container">
  <div class="row">
    <div class="col-md-12">
      <div class="error-template">
        <h1>
          {{util.translate('Oops!')}} </h1>
        <h2>
         {{util.translate('404 Page Not Found')}} </h2>
        <div class="error-details">
          {{util.translate('Sorry, an error has occured, Requested page not found!')}}
        </div>
        <div class="error-actions">
          <a href="/" class="btn btn-default btn-lg">
            {{util.translate('Back')}} </a>
          <a href="/" class="btn btn-default btn-lg">
            <span class="glyphicon glyphicon-envelope"></span> {{util.translate('Contact Support')}} </a>
        </div>
      </div>
    </div>
  </div>
</div>
